const tabletWidth = 640;
const desktopWidth = 1024;

export const isTablet = () => window.innerWidth >= tabletWidth;
export const isDesktop = () => window.innerWidth >= desktopWidth;
